import { LandingMainContent } from "@landing/components/landing/components/LandingMainContent"
import { useHashNavigation } from "@landing/components/landing/hooks/use-hash-navigation"
import { useMobileThemeColor } from "@landing/components/landing/hooks/use-mobile-theme-color"
import { useScrollReveal } from "@landing/components/landing/hooks/use-scroll-reveal"
import LandingBackground from "@landing/components/landing/LandingBackground"
import { LandingHeader } from "@landing/components/landing/LandingHeader"
import { LandingHeroLockup } from "@landing/components/landing/LandingHeroLockup"
import { LandingMarqueeTop } from "@landing/components/landing/LandingMarqueeTop"
import { LandingNav } from "@landing/components/landing/LandingNav"
import { LandingPauseAnimationOnHidden } from "@landing/components/landing/LandingPauseAnimationOnHidden"
import { LandingScrollIndicator } from "@landing/components/landing/LandingScrollIndicator"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  component: Landing,
})

function Landing() {
  const revealContent = useScrollReveal(100)
  const heroRef = LandingPauseAnimationOnHidden<HTMLElement>()

  useHashNavigation()
  useMobileThemeColor({
    light: "#001CFF", // Top-bar blue (matches landing header)
    dark: "#0a1129", // Changes when scrolling past threshold
    threshold: 80,
  })

  return (
    <div className="relative min-h-screen">
      <LandingBackground />

      {/* Fixed top marquee */}
      <div className="fixed top-0 -translate-y-[.2rem] left-0 right-0 z-500">
        <LandingMarqueeTop />
      </div>

      {/* Subtle logo header that fades out on scroll */}
      <LandingHeader />

      {/* Fixed navigation */}
      <div className="fixed top-[2.9rem] left-0 right-0 z-510">
        <LandingNav />
      </div>

      {/* Scroll indicator */}
      <LandingScrollIndicator />

      {/* Main content with proper spacing */}
      <div className="relative">
        {/* Hero and Intro occupy at least the first viewport */}
        <section
          ref={heroRef}
          id="hero"
          className="relative z-100 grid place-items-center min-h-svh md:min-h-screen md:pt-12"
        >
          <LandingHeroLockup />
        </section>

        {/* Main content sections */}
        <LandingMainContent revealContent={revealContent} />
      </div>
    </div>
  )
}
